'use strict';

angular.module('TurneroApp').service('reportesService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Reporte/:id', { id: '@Id' }, {
        Turnos_Por_Dia: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Turnos_Por_Dia/',
        },
        Turnos_Por_Agente: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Turnos_Por_Agente/',
        },
        Turnos_Por_Agenda: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Turnos_Por_Agenda/',
        },
        Turnos_Por_Tramite: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Turnos_Por_Tramite/',
        },
        Turnos_Por_Modalidad: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Turnos_Por_Modalidad/',
        },
        Reportes_Encuestas: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Reportes_Encuestas/'
        },
        Get_Turnos_Listado: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Turnos_Listado/'
        },
        Get_Turnos_Listado_Movimientos: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Turnos_Listado_Movimientos/'
        },
        getComboAgendas: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Agendas_X_Tramite',
            params: {
                id_centro_atencion: '@id_centro_atencion',
                id_tramite: '@id_tramite'
            }
        },
        getComboTramites: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Tramites_X_Agenda',
            params: {
                id_centro_atencion: '@id_centro_atencion',
                id_agenda: '@id_agenda'
            }
        },
        Get_Salidas_De_Atencion_X_Usuarios: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Salidas_De_Atencion_X_Usuarios'
        },
        Get_Estado_Salon_Cantidades: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Estado_Salon_Cantidades'
        },
        Get_Estado_Salon_Tiempos_Espera: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Estado_Salon_Tiempos_Espera'
        },
        Get_Usuarios_Centro_Atencion_Rol: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Usuarios_Centro_Atencion_Rol'
        },
        Get_Agendas_Turnos_Requiere_Reagendado: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Agendas_Turnos_Requiere_Reagendado'
        },
        Get_Cantidad_Turnos_Centro_Atencion_Reparticion: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Cantidad_Turnos_Centro_Atencion_Reparticion'
        },
        Get_Cantidad_Turnos_Tramite_Agenda: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Cantidad_Turnos_Tramite_Agenda'
        },
        Get_Cantidad_Turnos_Modalidad_Tramite: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Cantidad_Turnos_Tramite_Modalidad'
        },
        Get_Ultimo_Movimiento_Centro_Atencion: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Ultimo_Movimiento_Centro_Atencion'
        },
        Get_Ultimo_Movimiento_Usuario: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Ultimo_Movimiento_Usuario'
        },
        Get_Estado_Agendas_Centro_Atencion: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Estado_Agendas_Centro_Atencion'
        },
        Get_Turnos_Atendidos_Por_Agente: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Turnos_Atendidos_Por_Agente'
        },
        Get_Listado_Turnos_Movimientos_Total: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/Get_Listado_Turnos_Movimientos_Total/'
        },
        Get_Reporte_Vigencia_Definicion_Horaria_Agendas: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Reporte/getReporteVigenciaDefinicionHorariaAgendas/'
        }
	});
}]);



// WEBPACK FOOTER //
// ./app/components/reportes/reportesService.js